import {
  Admin,
  Ddf,
  List,
  Product,
  Stacking,
  Voting,
} from "../components/SidebarSVG";

export default [
  {
    id: 1,
    title: "DAO Voting",
    href: "/dao/voting",
    Icon: Voting,
  },
  {
    id: 2,
    title: "Staking",
    href: "/dao/staking",
    Icon: Stacking,
  },
  {
    id: 3,
    title: "Product Voting",
    href: "/dao/product-voting",
    Icon: Product,
  },
  {
    id: 4,
    title: "Product Submission",
    href: "/dao/submission",
    Icon: List,
  },
  {
    id: 5,
    title: "DDF",
    href: "/dao/ddf",
    Icon: Ddf,
  },
  {
    id: 6,
    title: "Admin",
    href: "/dao/admin",
    Icon: Admin,
  },
];
